<app-block-wrapper [_editable]="_editable" [style]="style">
  <h2 class="title">{{ title }}</h2>
  <div class="product-features">
    <ng-container *ngFor="let feature of mappedProductFeatures">
      <a
        class="feature clickable"
        [appStoryblok]="feature._editable"
        *ngIf="feature.featurePageLink?.cached_url"
        [routerLink]="feature.featurePageLink | storyblokLinkUrl"
      >
        <h3>
          {{ feature.title }}<span class="label label-primary in-flex" *ngIf="feature.new">NEW</span
          ><span class="label label-orange big" *ngIf="feature.comingSoon">SOON</span>
          <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
        </h3>
        <div [innerHtml]="feature.text | storyblokRichText"></div>
      </a>

      <div class="feature" *ngIf="!feature.featurePageLink?.cached_url" [appStoryblok]="feature._editable">
        <h3>
          {{ feature.title }}<span class="label label-primary in-flex" *ngIf="feature.new">NEW</span
          ><span class="label label-orange big" *ngIf="feature.comingSoon">SOON</span>
        </h3>
        <div [innerHtml]="feature.text | storyblokRichText" class="force-primary-links"></div>
      </div>
    </ng-container>
  </div>
</app-block-wrapper>
